export enum UnsavedChangesDialogOptions {
  Cancel = 'Cancel',
  Continue = 'Continue',
  Save = 'Save',
}
